import BaseService from 'services/base'

export default class WebshopFavouriteService extends BaseService {
  constructor(api, url = 'webshop/favourite') {
    super(api, url)
  }
}
